module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab128-79ccd3ba867c4f1122914de2662a1ee1.jpg";